<template>
  <page :title="title" :breadcrumb="breadcrumb">
    <div slot="pageAction">
      <div class="actionBlock" v-if="this.statsType !== 'new'">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              More Links...
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-card>
      <!-- <v-card-title>
        <div class="title" v-if="!newStatsType">{{statsType}} - {{desc}}</div>
        <div class="title" v-else>New Statistics Type</div>
      </v-card-title> -->
      <transition name="slide-x-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
export default {
  data() {
    return {
      title: 'Statistic Type and Value',
      breadcrumb: [],
      sideFunction: [
        // {
        //   text: 'Statistic Type and Value',
        //   icon: 'mdi-launch',
        //   iconColor: 'primary',
        //   params: { name: 'statsTypeDet' }
        // }
      ],
      desc: null
    }
  },
  created() {
    this.breadcrumb = this.derieveBreadcrumbByName('statsTypeVal')
    this.breadcrumb.push({
      text: this.title
    })
    this.$on('setDesc', (desc) => {
      this.desc = desc
    })
  },
  mounted() {
    this.doInit()
  },
  methods: {
    async doInit() {
      if (!this.newStatsType) {
        this.sideFunction.push({
          text: 'Permit Policy Type',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'polTypeStats' }
        })
        this.sideFunction.push({
          text: 'Permit Business Class',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'busClsStats' }
        })
        const apiURI = this.menu.statsType
        if (apiURI) {
          try {
            const expand = {
              statsType: this.statsType
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.desc = data.statsType.statsTypeDesc
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    menu() {
      return this.$store.state.statsTypeParam.menu
    },
    newStatsType() {
      return this.statsType === 'new'
    }
  },
  watch: {
    statsType(value) {
      this.doInit()
    }
  },
  components: {
    SideFunctionMenu
  },
  props: ['statsType']
}
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';
.queryPnl {
  margin-top: 50px;
}
</style>
